<template>
  <div class="linear-gauge">
    <div :class="[showOverlay ? showOverlayStyle : hideOverlayStyle ]">
      ADDITIONAL DATA NEEDED
    </div>
    <h6
      v-show="showTitle"
      class="linear-gauge__title"
      :style="{ fontSize: titleFontSize}"
    >
      {{ title }}
    </h6>
    <h6
      v-show="showHeroMetric && !showOverlay"
      class="linear-gauge__hero-metric"
    >
      {{ displayValue }}
    </h6>
    <div class="linear-gauge__bar-container">
      <div
        v-if="showLabels"
        v-text="min"
      ></div>
      <div :class="['linear-gauge__bar', distantGauge ]">
        <div
          v-show="!showOverlay"
          class="linear-gauge-cursor-container"
          :style="{ marginLeft: `${cursorWidth}%` }"
        >
          <div
            v-show="showDisplayVal"
            class="linear-gauge-cursor-value"
          >
            {{ displayValue }}
          </div>
          <div class="linear-gauge-cursor-vbar" />
        </div>
      </div>
      <div
        v-if="showLabels"
        v-text="max"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LinearGauge",
  props: {
    title: {},
    titleFontSize: {
      type: String,
      default: '1.2em'
    },
    showTitle:{
      type: Boolean,
      default: true,
    },
    showHeroMetric:{
      type: Boolean,
      default: false,
    },
    showDisplayVal: {
      type: Boolean,
      default: true
    },
    displayVal: Number,
    value: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    showLabels: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cursorWidth(){
      // returns a pct used to set cursor location on scale
      let scale = this.max - this.min;
      let correctedVal = (this.value - this.min) * 100;
      let widthPct = correctedVal / scale;
      // limit width % to  0 |<--->| 100
      if (widthPct > 100) {
        return 100;
      } else if (widthPct < 0) {
        return 0;
      } else {
        return widthPct;
      }
    },
    displayValue(){
      if (this.showHeroMetric){
        return this.title;
      } else {
        return this.displayVal || this.value;
      }
    },
    showOverlay(){
      return this.value == 0;
    },
    showOverlayStyle(){
      return 'linear-gauge__overlay';
    },
    hideOverlayStyle(){
      return 'hide';
    },
    distantGauge(){
      if (this.showOverlay){
        return 'distant'
      }
    },
  }
}
</script>

<style lang="scss">
    @import "../../../sass/vars";
    .linear-gauge{
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        padding: 20px;

        &__title{
            text-transform: uppercase;
        }
        &__hero-metric {
            font-size: 5em;
        }
        &__bar-container {
            margin: 12px;
            margin-top: 45px;
            padding-right: 6px;
            width: 100%;
            display: flex;
            gap: 10px;
            align-items: center;
        }
        &__bar {
          display: flex;
          border-radius: 10px;
          height: 20px;
          background: linear-gradient(to right, $red, $yellow, $green);
          width:100%;
        }
    }

    .linear-gauge-cursor-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
    }

    .linear-gauge-cursor-value {
        position: absolute;
        margin-top: -10px;
        font-size: 2em;
        bottom: 20px;
    }

    .linear-gauge-cursor-vbar {
        width: 6px;
        min-height: 25px;
        border-radius: 5px;
        background-color: #292929;
    }

    .linear-gauge__overlay {
        color: $green;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .hide {
        display: none;
    }
    .distant {
        transform:scale(0.8);
        opacity:0.1;
    }
</style>
